<template>
    <div class="BrandResultInfoItem">
        <div class="raw pt-4"
             v-for="(item, index) in posts" :key="index">

            <brand-result-info
                :title="`CONTENT NR${index + 1} WITH CHANGE TO VIEW THE CONTENT`"
                :insight="item.insight"
                :image="item.media_url"
                :isShowTooltip="true"
                :isShowPost="true"
            />
        </div>
    </div>
</template>

<style type="text/less" lang="less">

.BrandResultInfoItem {
    border-bottom: 10px solid #1825D8;

    h4 {
        font-size: 30px;
        font-weight: 900;
        letter-spacing: 9px;
        color: #1D2CF3;
    }
}

@media (max-width: 767px) {
    .BrandResultInfoItem {
        h4 {
            font-size: 16px;
            letter-spacing: 4px;
        }
    }
}
</style>

<script type="text/babel">
import BrandResultInfo from 'dashboard-js/components/brands/BrandResultInfo';
import PageLoader from 'dashboard-js/components/utilities/PageLoader';

export default {
    components: {
        BrandResultInfo,
        PageLoader
    },

    props: ['posts']
}
</script>
